import React, { useState } from "react";
import "../appFeatures.css";

const SECTIONS = [
  {
    title: "Water & Drainage",
    items: [
      "Deep borewell or dedicated Melamchi line present",
      "Reserve tank is over 10,000 liters",
      "Street drainage is clear (street is not lower than the main road)",
    ],
  },
  {
    title: "Structure & Power",
    items: [
      "Zero signs of dampness/peeling paint on lower walls",
      "South or East-facing windows for winter sunlight",
      "Working inverter/solar setup covering essential plugs",
    ],
  },
  {
    title: "Lease & Logistics",
    items: [
      "Building is pre-wired for major ISPs (WorldLink, Vianet, etc.)",
      "Landlord agrees to put Garbage & Tanker fee terms in writing",
    ],
  },
];

const MAX_SCORE = 80;
const POINTS_PER_ITEM = 10;

export default function FlatScorecard() {
  const [checked, setChecked] = useState(Array(8).fill(false));
  const [showResult, setShowResult] = useState(false);
  const totalScore = checked.filter(Boolean).length * POINTS_PER_ITEM;

  let verdict = "";
  let verdictColor = "#212529";
  let advice = "";
  let borderColor = "#ccc";
  if (showResult) {
    if (totalScore >= 70) {
      verdict = "Green Light: Rent It!";
      verdictColor = "#198754";
      advice =
        "This flat is a rare find in Kathmandu. It has the infrastructure to survive the monsoon and the dry season comfortably.";
      borderColor = "#198754";
    } else if (totalScore >= 50) {
      verdict = "Yellow Light: Negotiate Hard";
      verdictColor = "#ffc107";
      advice =
        "It's decent, but it lacks some basic infrastructure. Use these missing features to negotiate a lower rent price.";
      borderColor = "#ffc107";
    } else {
      verdict = "Red Light: Walk Away";
      verdictColor = "#dc3545";
      advice =
        "Do not rent this flat. The lack of water and power infrastructure will make living here miserable during extreme weather.";
      borderColor = "#dc3545";
    }
  }

  return (
    <div
      style={{
        backgroundColor: "#f8f9fa",
        padding: 25,
        borderRadius: 8,
        border: "1px solid #e9ecef",
        maxWidth: 600,
        margin: "20px auto",
        fontFamily: "sans-serif",
      }}
    >
      <h3 style={{ marginTop: 0, color: "#212529" }}>
        The Kathmandu Flat Scorecard
      </h3>
      <p style={{ fontSize: 14, color: "#6c757d", marginBottom: 20 }}>
        Check the boxes for the features the apartment actually has (not just
        what the broker promises). Let's see if it passes the test.
      </p>
      {SECTIONS.map((section, i) => (
        <div
          key={section.title}
          style={{
            backgroundColor: "#fff",
            padding: 15,
            borderRadius: 6,
            border: "1px solid #dee2e6",
            marginBottom: 15,
          }}
        >
          <h4 style={{ marginTop: 0, marginBottom: 10, color: "#0d6efd" }}>
            {section.title}
          </h4>
          {section.items.map((item, j) => (
            <label
              key={item}
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 8,
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={checked[i * 3 + j] || false}
                onChange={() => {
                  const idx = i * 3 + j;
                  setChecked((prev) => {
                    const arr = [...prev];
                    arr[idx] = !arr[idx];
                    return arr;
                  });
                }}
                style={{ marginRight: 10, width: 16, height: 16 }}
              />
              {item}
            </label>
          ))}
        </div>
      ))}
      <button
        onClick={() => setShowResult(true)}
        style={{
          backgroundColor: "#198754",
          color: "white",
          border: "none",
          padding: "12px 20px",
          borderRadius: 4,
          width: "100%",
          fontSize: 16,
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        Calculate My Score
      </button>
      {showResult && (
        <div
          style={{
            display: "block",
            marginTop: 20,
            padding: 20,
            borderRadius: 4,
            textAlign: "center",
            border: `2px solid ${borderColor}`,
          }}
        >
          <h2 style={{ margin: "0 0 5px 0", fontSize: 36, color: "#212529" }}>
            {totalScore} / {MAX_SCORE}
          </h2>
          <h4
            style={{ margin: "0 0 10px 0", fontSize: 20, color: verdictColor }}
          >
            {verdict}
          </h4>
          <p style={{ margin: 0, fontSize: 14, color: "#495057" }}>{advice}</p>
        </div>
      )}
    </div>
  );
}
